<template>
  <div class="container">
    <div class="becalled_header">
      <date-switcher
        @switch="handleRangeChange"
        rangeType="week"
      ></date-switcher>
    </div>
    <el-table
      size="mini"
      ref="multipleTable"
      tooltip-effect="dark"
      style="width: 100%; margin-top: 20px"
      :data="tableData"
      border
      v-horizontal-scroll
      stripe
      @sort-change="handleSortChange"
      :default-sort="{ prop: 'date', order: 'ascending' }"
    >
      <el-table-column label="班级名称" prop="class.name"></el-table-column>
      <el-table-column label="上课教室" prop="classroom.name">
        <template slot-scope="scope">{{
          scope.row.classroom ? scope.row.classroom.name : "-"
        }}</template>
      </el-table-column>
      <el-table-column
        label="上课时间"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
        prop="date"
      >
        <template slot-scope="scope">
          <div>
            {{ getTime(new Date(scope.row.date)) }}
            {{ scope.row.start_time.slice(0, 5) }}~{{
              scope.row.end_time.slice(0, 5)
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="授课教师">
        <template slot-scope="scope">
          <div>
            <span v-for="(item, index) in scope.row.teacher_list" :key="index">
              {{ item.name }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="上课内容"
        prop="class_lesson_extend.content"
        class-name="classCon"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.class_lesson_extend.content">
            {{ scope.row.class_lesson_extend.content }}
          </span>
          <span v-else> - </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
  </div>
</template>
<script>
import dateSwitcher from "@/components/dateSwitcher.vue";
import { dateFormat } from "@/utils/timeFormat";
import { getlessonlist } from "@/api/studyDetails";

export default {
  components: {
    dateSwitcher,
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 20],
      total: 5,
      tableData: [],
      searchInfo: {
        sort_type: "desc",
        sort_field: "",
      },
      id: 0,
      start_date_weed: "", //周日期开始
      end_date_weed: "", //周日期结束
    };
  },
  created() {
    this.id = Number(this.$route.query.id);
    // this.getlessonlistdata({
    //   page: this.page,
    //   page_size: this.pageSize,
    // });
  },
  methods: {
    // 排序请求
    handleSortChange(e) {
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      if (e.prop === "date") {
        this.searchInfo.sort_field = "full_start_time";
        this.getlessonlistdata({
          page: this.page,
          page_size: this.pageSize,
        });
      }
    },
    //待点名接口
    getlessonlistdata(data) {
      const _t = this;
      data.roll_call_status = 1;
      data.student_id = _t.id;
      data.start_date = _t.start_date_weed;
      data.end_date = _t.end_date_weed;
      if (_t.searchInfo.sort_type != "") {
        data.sort_type = _t.searchInfo.sort_type;
      }
      if (_t.searchInfo.sort_field != "") {
        data.sort_field = _t.searchInfo.sort_field;
      }
      if (data.start_date === "" || data.end_date === "") {
        return;
      }
      getlessonlist(data).then((res) => {
        if (res.error_code == 0) {
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
        }
      });
    },
    // 周几
    getTime(e) {
      const weekZh = ["日", "一", "二", "三", "四", "五", "六"];
      const v = "（周" + weekZh[e.getDay()] + "）";
      const format = dateFormat("YYYY-mm-dd", e);
      return format.slice(0, 10) + v + format.slice(11);
    },
    // 时间格式化
    dateYearMonthDay(unixtime) {
      const dateTime = new Date(unixtime);
      const year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      if (month > 0 && month < 10) {
        month = "0" + month;
      }
      let day = dateTime.getDate();
      if (day > 0 && day < 10) {
        day = "0" + day;
      }
      const timeSpanStr = year + "-" + month + "-" + day;
      return timeSpanStr;
    },
    handleRangeChange(data) {
      const _t = this;
      _t.start_date_weed = _t.dateYearMonthDay(data[0]);
      _t.end_date_weed = _t.dateYearMonthDay(data[1]);
      _t.getlessonlistdata({
        page: 1,
        page_size: 10,
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getlessonlistdata({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getlessonlistdata({
        page: this.page,
        page_size: this.pageSize,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
